import { render, staticRenderFns } from "./mobilepdf.vue?vue&type=template&id=6b5b2ef3&scoped=true&"
import script from "./mobilepdf.vue?vue&type=script&lang=js&"
export * from "./mobilepdf.vue?vue&type=script&lang=js&"
import style0 from "./mobilepdf.vue?vue&type=style&index=0&id=6b5b2ef3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5b2ef3",
  null
  
)

export default component.exports